import React from "react";
import { Button } from "reactstrap";
import { favoritesRepo } from "data/repositories/favoritesRepo";

export default function FavoriteButton({ type, id, favorites, onToggle }) {
  const isSaved =
    type === "province"
      ? (favorites?.provinceIds || []).includes(id)
      : (favorites?.dealIds || []).includes(id);

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const next =
      type === "province"
        ? favoritesRepo.toggleProvince(id)
        : favoritesRepo.toggleDeal(id);
    if (onToggle) onToggle(next);
  };

  return (
    <Button color="link" className="p-0" onClick={handleClick} title={isSaved ? "Favoriden çıkar" : "Favoriye ekle"}>
      <i className={isSaved ? "fas fa-heart text-danger" : "far fa-heart text-muted"} />
    </Button>
  );
}
